<template>
    <div v-if="paymentMethods && paymentMethods.masterpass">
        <div v-if="cardSelected === false">
            <div v-html="$t('_checkout._payment.walletInstructionsHtmlX', ['Masterpass'])" />

            <div class="text-right">
                <img
                    class="cursor-pointer"
                    src="https://masterpass.com/dyn/img/btn/global/mp_chk_btn_147x034px.svg"
                    @click.prevent="callMasterpass()"
                />
            </div>
        </div>
        <div v-else>
            <div class="alert d-flex flex-align-center mb">
                <i class="icon-cr icon-ok mr flex-child-fixed"></i>
                <span>{{
                        $t('_checkout._payment.walletCardSuccessfullySelectedX', ['Masterpass'])
                    }}</span>
            </div>

            <SelectField
                v-if="paymentMethods"
                v-model="installmentsSelected"
                :error.sync="installmentsError"
                :label="$t('_checkout._payment._card.selectInstallments')"
            >
                <option :value="null"></option>
                <option v-for="option in paymentMethods.cartoesdecredito" :value="option">
                    {{ option.total_installments }}x {{ $t('of') }}
                    {{ $f.formatMoney(option.installments[0]) }} &nbsp;(Total
                    {{ $f.formatMoney(option.total) }}
                    <template v-if="option.interests > 0">
                        ,
                        {{
                            $t('_checkout._payment._card.interestsMonth', [
                                formatNumber(option.interests, 2),
                            ])
                        }})
                    </template>
                    <template v-else>, {{ $t('_shop.interestFree') }})</template>
                </option>
            </SelectField>
        </div>
    </div>
</template>

<script>
    import CheckoutPaymentMethod from './CheckoutPaymentMethod';
    import accounting from '../../../../helpers/accounting';
    import SelectField from '../../../../components/input/select-field/SelectField.vue';
    import { readUrlQuery } from '../../../../script/common';

    export default {
        extends: CheckoutPaymentMethod,

        name: 'CheckoutPaymentMasterpass',

        components: { SelectField },

        props: ['cart', 'customer', 'paymentMethods'],

        data() {
            return {
                cardSelected: false,
                installmentsSelected: undefined,
                walletPayload: undefined,
                isReturning: false,
                installmentsError: null,
            };
        },

        computed: {
            description() {
                if (!this.installmentsSelected) return 'Masterpass';

                const installments =
                    (this.installmentsSelected.total_installments || 1) === 1
                        ? this.$t('_shop.inCash')
                        : this.$tc(
                            '_shop.installmentsX',
                            this.installmentsSelected.total_installments || 1
                        );
                return `Masterpass - ${installments}`;
            },
        },

        watch: {
            paymentMethods: function (to) {
                if (to) {
                    if (this.isReturning) {
                        this.isReturning = false;
                    } else {
                        this.resetMethod();
                    }
                }
            },

            cardSelected: {
                immediate: true,
                handler(to) {
                    this.storeState.payment.masterpassIsReady = to;
                },
            },
        },

        // Executado somente uma vez pois o componente está com keep-alive
        created() {
            const oauthToken = readUrlQuery('oauth_token');

            if (oauthToken && oauthToken.trim().length > 0) {
                this.isReturning = true;

                if (readUrlQuery('mpstatus') === 'cancel') {
                    this.$emit(
                        'error',
                        this.$t('_checkout._payment.errorWalletCancelledX', ['Masterpass'])
                    );
                } else {
                    this.cardSelected = true;
                    this.walletPayload = {
                        oauthToken: oauthToken,
                        oauth_verifier: readUrlQuery('oauth_verifier'),
                        checkoutId: readUrlQuery('checkoutId'),
                        checkout_resource_url: readUrlQuery('checkout_resource_url'),
                    };
                }
            }
        },

        methods: {
            formatNumber(value, precision) {
                return accounting.formatNumber(value, precision);
            },

            resetMethod() {
                this.cardSelected = false;
                this.installmentsSelected = undefined;
                this.walletPayload = undefined;
            },

            callMasterpass() {
                if (!window.masterpass) {
                    this.$emit(
                        'error',
                        this.$t('_checkout._payment.errorWalletConnectionTryAgain', ['Masterpass'])
                    );
                    return;
                }

                window.masterpass.checkout({
                    checkoutId: this.$scope.checkoutPreferences.masterpassCheckoutId,
                    allowedCardTypes: ['master,amex,diners,discover,jcb,visa'],
                    amount: this.cart.total_paid.toString(),
                    currency: 'BRL',
                    suppressShippingAddress: true,
                    cartId: this.cart.id.toString(),
                });
            },

            paymentSuccess(data) {
                this.cardSelected = true;
                this.walletPayload = {
                    callid: data.callid,
                    encKey: data.encKey,
                    encPaymentData: data.encPaymentData,
                };
            },

            submit(callback) {
                if (!this.cardSelected) return;

                if (!this.installmentsSelected) {
                    this.installmentsError = this.$t('_checkout._payment._card.selectInstallments');
                    return;
                }

                callback({
                    module: 'cartoesdecredito',
                    installments: this.installmentsSelected.total_installments,
                    wallet: true,
                    walletType: 'masterpass',
                    walletPayload: this.walletPayload,
                });
            },
        },
    };
</script>
